"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessagesRoutes = void 0;
const route_1 = require("../route");
class MessagesRoutes extends route_1.Route {
    constructor() {
        super('messages');
    }
    getMessages() {
        return this.get('/');
    }
    getFeedBannerObjects() {
        return this.get('/feed');
    }
}
exports.MessagesRoutes = MessagesRoutes;
//# sourceMappingURL=messages.js.map